var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "destroy-on-close": true,
            visible: _vm.orderPreShow,
            "custom-class": "OrderPre-Dialog",
            "modal-append-to-body": "",
            title: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderPreShow = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "Pre-Content" },
            [
              _c(
                "div",
                { staticClass: "Pre-Name" },
                [
                  _c("div", { staticClass: "Pre-Name-IK" }, [
                    _c(
                      "span",
                      {
                        staticClass: "Title",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [_vm._v(_vm._s(_vm.dataMap.planName))]
                    ),
                    _c("img", {
                      staticClass: "Close-Style",
                      attrs: {
                        src: require("@/assets/png/gjpink.png"),
                        alt: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.orderPreShow = false
                        },
                      },
                    }),
                  ]),
                  _c("el-divider"),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "Main-Date" },
                [
                  _c("span", { staticClass: "_span" }, [
                    _vm._v("团号：" + _vm._s(_vm.dataMap.planId)),
                  ]),
                  _c("div", { staticClass: "Main-Date-Two" }, [
                    _c("span", { staticClass: "_span" }, [
                      _vm._v(
                        _vm._s(_vm.dataMap.startTime) +
                          " 至 " +
                          _vm._s(_vm.dataMap.endTime)
                      ),
                    ]),
                    _c("span", { staticClass: "_span" }, [
                      _vm._v(" " + _vm._s(_vm.dataMap.numberOfPeople) + "人"),
                    ]),
                  ]),
                  _c("el-divider"),
                ],
                1
              ),
              _c("div", { staticClass: "Coupon" }, [
                _c(
                  "span",
                  { staticClass: "Title", staticStyle: { color: "gray" } },
                  [_vm._v("优惠")]
                ),
                _c("div", { staticClass: "Coupon-One _margin" }, [
                  _c("div", { staticClass: "Coupon-One-IK" }, [
                    _c("img", {
                      staticClass: "_img",
                      attrs: {
                        src: require("@/assets/png/coupon.png"),
                        alt: "",
                      },
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "_span",
                        staticStyle: { "padding-left": "5px" },
                      },
                      [_vm._v("优惠券")]
                    ),
                  ]),
                  _c(
                    "span",
                    { staticStyle: { color: "#DD5827", "font-size": "12px" } },
                    [_vm._v("暂无可用")]
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "Integral" },
                [
                  _c("div", { staticClass: "Integral-One" }, [
                    _c("div", { staticClass: "Integral-One-IK" }, [
                      _c("img", {
                        staticClass: "_img",
                        attrs: {
                          src: require("@/assets/png/Integral1.png"),
                          alt: "",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "_span",
                          staticStyle: { "padding-left": "5px" },
                        },
                        [_vm._v("积分")]
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#DD5827", "font-size": "12px" },
                      },
                      [_vm._v("暂无可用积分")]
                    ),
                  ]),
                  _c("el-divider"),
                ],
                1
              ),
              _c("div", { staticClass: "Total-Price" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "flex-direction": "column",
                    },
                  },
                  [
                    _vm.originalCurrency
                      ? _c("p", { staticClass: "_p" }, [
                          _c("span", { staticClass: "_span" }, [
                            _vm._v("原币金额："),
                          ]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#DD5827",
                                "font-size": "0.16rem",
                              },
                            },
                            [_vm._v(_vm._s(_vm.originalCurrency))]
                          ),
                        ])
                      : _vm._e(),
                    _c("p", { staticClass: "_p" }, [
                      _c("span", { staticClass: "_span" }, [
                        _vm._v("订单金额："),
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#DD5827",
                            "font-size": "0.16rem",
                          },
                        },
                        [_vm._v("¥ " + _vm._s(_vm.dataMap.totalPrice))]
                      ),
                    ]),
                    _c("p", { staticClass: "_p" }, [
                      _c("span", { staticClass: "_span" }, [
                        _vm._v("实付金额："),
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#DD5827",
                            "font-size": "0.16rem",
                          },
                        },
                        [_vm._v("¥ " + _vm._s(_vm.dataMap.actualPrice))]
                      ),
                    ]),
                    _vm.dataMap.stateMaps
                      ? _vm._l(
                          _vm.dataMap.stateMaps.filter(
                            (x) => x.inventoryExpiredTotalPrice > 0
                          ),
                          function (item, index) {
                            return _c("p", { key: index, staticClass: "_p" }, [
                              _c("span", { staticClass: "_span" }, [
                                _vm._v(_vm._s(item.stateName) + "库存不足："),
                              ]),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#DD5827",
                                    "font-size": "0.16rem",
                                  },
                                },
                                [
                                  _vm._v(
                                    "-¥ " +
                                      _vm._s(item.inventoryExpiredTotalPrice)
                                  ),
                                ]
                              ),
                            ])
                          }
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      "justify-content": "center",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { width: "100%", "margin-bottom": "20px" },
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "10px" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.orderType,
                                  callback: function ($$v) {
                                    _vm.orderType = $$v
                                  },
                                  expression: "orderType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "self" } }, [
                                  _vm._v("自己公司接单"),
                                ]),
                                _c(
                                  "el-radio",
                                  { attrs: { label: "supplier" } },
                                  [_vm._v("指定供应商接单")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.orderType === "supplier"
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入指定供应商编号",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.companyId,
                                    callback: function ($$v) {
                                      _vm.companyId =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "companyId",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { background: "#DD5827", height: "40px" },
                        attrs: {
                          loading: _vm.isLoading,
                          round: "",
                          type: "danger",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.placeOrder(false)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.isLoading ? "提交中" : "提交订单") + " "
                        ),
                      ]
                    ),
                    _c("div", { staticStyle: { "margin-top": "10px" } }, [
                      _c(
                        "span",
                        {
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function ($event) {
                              return _vm.$refs.disclaimerClausePopUpBox.open()
                            },
                          },
                        },
                        [_vm._v("查看免责条款")]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              true
                ? _c("PriceDetail", {
                    ref: "priceDetail",
                    staticStyle: { "margin-top": "30px" },
                    on: { inventoryPolicyDisplay: _vm.inventoryPolicyDisplay },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("Lbox", { ref: "inventoryPolicyDisplayRef" }),
          _c("pay", {
            ref: "thirdPay",
            attrs: {
              dataMap: _vm.dataMap,
              orderChildrenIds: _vm.childrenIds,
              orderMainId: _vm.orderMainId,
              payMoney: _vm.dataMap.totalPrice,
            },
            on: { payUpload: _vm.payUpload },
          }),
        ],
        1
      ),
      _c("createAVehicleOrder", {
        ref: "createAVehicleOrder",
        on: {
          confirmed: function ($event) {
            return _vm.placeOrder(true)
          },
        },
      }),
      _c("total-order-pop-up-box", {
        ref: "TotalOrderPopUpBox",
        on: {
          close: function ($event) {
            _vm.orderPreShow = false
          },
        },
      }),
      _c("disclaimerClausePopUpBox", { ref: "disclaimerClausePopUpBox" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }